import React, { useEffect } from "react";

const DivisionChallenge = () => {
  useEffect(() => {
    loadQuestion();
  }, []);

  const problems = [
      { question: "128 ÷ 2", hint: "🧠 Hint: 120 ÷ 2 + 8 ÷ 2", answer: 64 },
  { question: "135 ÷ 5", hint: "🧠 Hint: 100 ÷ 5 + 35 ÷ 5", answer: 27 },
  { question: "216 ÷ 6", hint: "🧠 Hint: 210 ÷ 6 + 6 ÷ 6", answer: 36 },
  { question: "224 ÷ 7", hint: "🧠 Hint: 210 ÷ 7 + 14 ÷ 7", answer: 32 },
  { question: "324 ÷ 9", hint: "🧠 Hint: 270 ÷ 9 + 54 ÷ 9", answer: 36 },
  { question: "468 ÷ 3", hint: "🧠 Hint: 300 ÷ 3 + 150 ÷ 3 + 18 ÷ 3", answer: 156 },
  { question: "576 ÷ 6", hint: "🧠 Hint: 480 ÷ 6 + 60 ÷ 6 + 36 ÷ 6", answer: 96 },
  { question: "648 ÷ 9", hint: "🧠 Hint: 540 ÷ 9 + 108 ÷ 9", answer: 72 },
  { question: "729 ÷ 9", hint: "🧠 Hint: 720 ÷ 9 + 9 ÷ 9", answer: 81 },
  { question: "816 ÷ 4", hint: "🧠 Hint: 800 ÷ 4 + 16 ÷ 4", answer: 204 },
  { question: "864 ÷ 8", hint: "🧠 Hint: 800 ÷ 8 + 64 ÷ 8", answer: 108 },
  { question: "924 ÷ 7", hint: "🧠 Hint: 700 ÷ 7 + 210 ÷ 7 + 14 ÷ 7", answer: 132 },
  { question: "936 ÷ 6", hint: "🧠 Hint: 900 ÷ 6 + 36 ÷ 6", answer: 156 },
  { question: "972 ÷ 9", hint: "🧠 Hint: 900 ÷ 9 + 72 ÷ 9", answer: 108 },
  { question: "999 ÷ 3", hint: "🧠 Hint: 900 ÷ 3 + 90 ÷ 3 + 9 ÷ 3", answer: 333 }
  ];

  let shuffledProblems = problems;
  let currentProblemIndex = 0;

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  function loadQuestion() {
    const problem = shuffledProblems[currentProblemIndex];
    document.getElementById("question").innerHTML = `<h2>🤔 ${problem.question} = ?</h2>`;
    document.getElementById("hint").innerText = `💡 ${problem.hint}`;
    document.getElementById("feedback").innerText = "";
    document.getElementById("userAnswer").value = "";
  }

  function checkAnswer() {
    const userInput = parseInt(document.getElementById("userAnswer").value);
    const correctAnswer = shuffledProblems[currentProblemIndex].answer;
    const feedback = document.getElementById("feedback");

    if (userInput === correctAnswer) {
      document.getElementById("correctSound").play();
      feedback.innerHTML = `<span class="correct">🎉 Correct! Great job!</span>`;
      currentProblemIndex++;

      if (currentProblemIndex < shuffledProblems.length) {
        setTimeout(loadQuestion, 2000);
      } else {
        feedback.innerHTML += "<br><br>🏁🎊 You’ve completed all Level 2 questions!";
      }
    } else {
      document.getElementById("wrongSound").play();
      feedback.innerHTML = `<span class="incorrect">❌ Not quite! Try again!</span>`;
    }
  }

  function nextQuestion() {
    if (currentProblemIndex < shuffledProblems.length - 1) {
      currentProblemIndex++;
      loadQuestion();
    }
  }

  function prevQuestion() {
    if (currentProblemIndex > 0) {
      currentProblemIndex--;
      loadQuestion();
    }
  }

  return (
    <div
      style={{
        fontFamily: "'Fredoka One', cursive",
        background: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
        textAlign: "center",
        padding: "40px",
        color: "#4e2600",
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          fontSize: "2.7em",
          color: "#ff6600",
          marginBottom: "30px",
          textShadow: "2px 2px 0 #fff0cc",
        }}
      >
        Level 2: Medium Division Challenge 🧮
      </h1>

      <div
        className="question-box"
        style={{
          background: "#fffbe6",
          border: "5px dashed #ffa500",
          borderRadius: "30px",
          padding: "40px",
          width: "65%",
          margin: "0 auto",
          boxShadow: "0 12px 30px rgba(0, 0, 0, 0.15)",
          animation: "bounce 1.2s ease-in-out infinite alternate",
        }}
      >
        <div id="question"></div>
        <div
          className="hint"
          id="hint"
          style={{ fontSize: "1.2rem", color: "#884400", marginBottom: "20px" }}
        ></div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <input
            type="number"
            id="userAnswer"
            style={{
              padding: "12px",
              fontSize: "1.5rem",
              width: "140px",
              border: "3px solid #ff9933",
              borderRadius: "12px",
              backgroundColor: "#fff7e6",
            }}
          />

          {/* Navigation buttons */}
          <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
            <button
              onClick={prevQuestion}
              style={{
                padding: "10px 20px",
                fontSize: "1.1rem",
                backgroundColor: "#ffb84d",
                color: "white",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                boxShadow: "2px 4px 8px rgba(0,0,0,0.2)",
              }}
            >
              ⬅ Previous
            </button>

            <button
              onClick={nextQuestion}
              style={{
                padding: "10px 20px",
                fontSize: "1.1rem",
                backgroundColor: "#ffb84d",
                color: "white",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                boxShadow: "2px 4px 8px rgba(0,0,0,0.2)",
              }}
            >
              Next ➡
            </button>
          </div>
        </div>

        <br />
        <button
          onClick={checkAnswer}
          style={{
            padding: "12px 30px",
            fontSize: "1.3rem",
            backgroundColor: "#ff9933",
            color: "white",
            border: "none",
            borderRadius: "15px",
            cursor: "pointer",
            marginTop: "20px",
            boxShadow: "2px 4px 10px rgba(0, 0, 0, 0.2)",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#e67e22")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#ff9933")}
        >
          ✅ Submit
        </button>

        <div
          className="feedback"
          id="feedback"
          style={{
            fontSize: "1.6rem",
            marginTop: "25px",
            fontWeight: "bold",
          }}
        ></div>
      </div>

      {/* Sound Effects */}
      <audio
        id="correctSound"
        src="https://www.soundjay.com/human/kids-cheering-01.mp3"
      ></audio>
      <audio
        id="wrongSound"
        src="https://www.soundjay.com/button/beep-07.mp3"
      ></audio>

      <style>{`
        @keyframes bounce {
          0% { transform: translateY(0); }
          100% { transform: translateY(-10px); }
        }
        .correct { color: green; }
        .incorrect { color: red; }
      `}</style>
    </div>
  );
};

export default DivisionChallenge;
